import { Component } from '@angular/core';
import { PIE_PANEL_IMPORTS, PiePanelComponent } from 'src/app/panels/components/pie/pie-panel/pie-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.html',
  styleUrl: '../../../../panels/components/pie/pie-panel/pie-panel.component.scss',
  selector: 'app-category-pie-panel',
  imports: PIE_PANEL_IMPORTS,
})
export class CategoryPiePanelComponent extends PiePanelComponent {
  public static override readonly type = PanelType.ElectricityCategoryPie;
  public override title = 'Verbruik per categorie';
  public override icon = 'bi-lightning-charge-fill';
  public override unit = DisplayUnit.Kwh;
}
